import { render, staticRenderFns } from "./IYBIndicatorBreakdown.vue?vue&type=template&id=8735eed4&scoped=true"
import script from "./IYBIndicatorBreakdown.vue?vue&type=script&lang=js"
export * from "./IYBIndicatorBreakdown.vue?vue&type=script&lang=js"
import style0 from "./IYBIndicatorBreakdown.vue?vue&type=style&index=0&id=8735eed4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8735eed4",
  null
  
)

export default component.exports